import { t } from "@/i18n-js/instance";
import { Icon } from "@/react/components/shared/Icon";
import { Accordion } from "@/react/components/shared/uikit/Accordion";
import { Typography } from "@/react/components/shared/uikit/Typography";
import { UserImageWithFallback } from "@/react/components/shared/uikit/UserImageWithFallback";
import { useModal } from "@circle-react/components/Layout/ModalManagerProvider";
import { Button } from "@circle-react-uikit/Button";
import { Loader } from "@circle-react-uikit/Loader";
import type { SnippetPreview } from "../snippetsQueries";
import { ResourceDetails } from "./ResourceDetails";

export const Details = ({
  snippet,
}: {
  snippet: SnippetPreview | undefined;
}) => {
  const modal = useModal();

  return (
    <div className="h-full w-[344px] overflow-hidden">
      {snippet === undefined ? (
        <div className="flex h-full flex-1 items-center justify-center">
          <Loader />
        </div>
      ) : (
        <>
          <div className="border-primary flex h-[72px] items-center justify-between border-b p-6">
            <Typography.LabelLg weight="semibold">
              <Typography.LabelLg weight="semibold">
                {t(
                  "settings.community_bot.knowledge.custom.preview_drawer.details",
                )}
              </Typography.LabelLg>
            </Typography.LabelLg>
            <Button onClick={modal.hide} variant="text">
              <Icon type="24-close" size={24} />
            </Button>
          </div>
          <div className="border-primary border-b px-6 pb-1 pt-6">
            <Accordion
              defaultActiveItemTitle={t(
                "settings.community_bot.knowledge.custom.preview_drawer.details_section.assigned_to",
              )}
            >
              <Accordion.Item
                title={t(
                  "settings.community_bot.knowledge.custom.preview_drawer.details_section.assigned_to",
                )}
              >
                <div className="pb-6">
                  {snippet.community_bot_profiles.length === 0 ? (
                    <Typography.LabelSm>
                      {t(
                        "settings.community_bot.knowledge.custom.preview_drawer.details_section.not_assigned",
                      )}
                    </Typography.LabelSm>
                  ) : (
                    <div className="flex flex-col gap-2">
                      {snippet.community_bot_profiles.map(profile => (
                        <div
                          key={profile.id}
                          className="text-dark bg-tertiary border-primary flex w-full flex-row gap-2 rounded-lg border p-2 text-base"
                        >
                          {profile.avatar_url ? (
                            <UserImageWithFallback
                              src={profile.avatar_url}
                              name={profile.name}
                              size="5"
                              isFullRounded
                            />
                          ) : (
                            <Icon
                              type="20-ai-bot"
                              size={20}
                              className="!h-[1.25rem] !w-[1.25rem]"
                            />
                          )}

                          <Typography.BodySm truncate>
                            {profile.name}
                          </Typography.BodySm>
                        </div>
                      ))}
                    </div>
                  )}
                </div>
              </Accordion.Item>
            </Accordion>
          </div>
          <div className="border-primary border-b px-6 pb-1 pt-6">
            <Accordion
              defaultActiveItemTitle={t(
                "settings.community_bot.knowledge.custom.preview_drawer.details_section.resource",
              )}
            >
              <Accordion.Item
                title={t(
                  "settings.community_bot.knowledge.custom.preview_drawer.details_section.resource",
                )}
              >
                <ResourceDetails snippet={snippet} />
              </Accordion.Item>
            </Accordion>
          </div>
        </>
      )}
    </div>
  );
};
